export const ACCESS_ROLE_NEW_HIRE = 'new_hire'
export const ACCESS_ROLE_EMPLOYEE = 'employee'
export const ACCESS_ROLE_SHIFT_LEAD = 'shift_lead'
export const ACCESS_ROLE_MANAGER = 'manager'
export const ACCESS_ROLE_OWNER_MANAGER = 'owner_manager'
export const ACCESS_ROLE_OPERATIONS_SUPPORT = 'operations_support'
export const ACCESS_ROLE_ADMIN = 'admin'

export const WORK_STATUS_PENDING_ONBOARDING = 'pending_onboarding'
export const WORK_STATUS_ACTIVE = 'active'
export const WORK_STATUS_PAUSED = 'paused'
export const WORK_STATUS_SUSPENDED = 'suspended'
export const WORK_STATUS_TERMINATED = 'terminated'
export const WORK_STATUS_ARCHIVED = 'archived'

export const ACCESS_ROLES = Object.freeze([
  ACCESS_ROLE_NEW_HIRE,
  ACCESS_ROLE_EMPLOYEE,
  ACCESS_ROLE_SHIFT_LEAD,
  ACCESS_ROLE_MANAGER,
  ACCESS_ROLE_OWNER_MANAGER,
  ACCESS_ROLE_OPERATIONS_SUPPORT,
  ACCESS_ROLE_ADMIN
])

export const WORK_STATUSES = Object.freeze([
  WORK_STATUS_PENDING_ONBOARDING,
  WORK_STATUS_ACTIVE,
  WORK_STATUS_PAUSED,
  WORK_STATUS_SUSPENDED,
  WORK_STATUS_TERMINATED,
  WORK_STATUS_ARCHIVED
])

export const DEFAULT_ACCESS_ROLE = ACCESS_ROLE_EMPLOYEE
export const DEFAULT_WORK_STATUS = WORK_STATUS_PENDING_ONBOARDING

const LEGACY_ROLE_ALIASES = Object.freeze({
  supervisor: ACCESS_ROLE_SHIFT_LEAD
})

const WORK_STATUS_ALIASES = Object.freeze({
  onboarding: WORK_STATUS_PENDING_ONBOARDING,
  'pending onboarding': WORK_STATUS_PENDING_ONBOARDING,
  inactive: WORK_STATUS_PAUSED,
  deactivated: WORK_STATUS_PAUSED
})

export const ACCESS_ROLE_LABELS = Object.freeze({
  [ACCESS_ROLE_NEW_HIRE]: 'New Hire',
  [ACCESS_ROLE_EMPLOYEE]: 'Employee',
  [ACCESS_ROLE_SHIFT_LEAD]: 'Shift Lead',
  [ACCESS_ROLE_MANAGER]: 'Manager',
  [ACCESS_ROLE_OWNER_MANAGER]: 'Owner Manager',
  [ACCESS_ROLE_OPERATIONS_SUPPORT]: 'Operations Support',
  [ACCESS_ROLE_ADMIN]: 'Admin'
})

export const WORK_STATUS_LABELS = Object.freeze({
  [WORK_STATUS_PENDING_ONBOARDING]: 'Pending Onboarding',
  [WORK_STATUS_ACTIVE]: 'Active',
  [WORK_STATUS_PAUSED]: 'Paused',
  [WORK_STATUS_SUSPENDED]: 'Suspended',
  [WORK_STATUS_TERMINATED]: 'Terminated',
  [WORK_STATUS_ARCHIVED]: 'Archived'
})

export const normalizeAccessRole = (value) => {
  if (!value) return DEFAULT_ACCESS_ROLE
  const normalized = String(value).trim().toLowerCase()
  const canonicalFromLegacy = LEGACY_ROLE_ALIASES[normalized]
  if (canonicalFromLegacy) return canonicalFromLegacy
  return ACCESS_ROLES.includes(normalized) ? normalized : DEFAULT_ACCESS_ROLE
}

export const normalizeAccessRoleValue = normalizeAccessRole

export const toLegacyRoleValue = (value) => {
  const canonicalRole = normalizeAccessRole(value)
  if (canonicalRole === ACCESS_ROLE_SHIFT_LEAD) return 'supervisor'
  return canonicalRole
}

export const normalizeWorkStatus = (value) => {
  if (!value) return WORK_STATUS_ACTIVE
  const normalized = String(value).trim().toLowerCase().replace(/-/g, '_')
  if (WORK_STATUSES.includes(normalized)) return normalized
  const withSpaces = normalized.replace(/_/g, ' ')
  const canonicalFromAlias = WORK_STATUS_ALIASES[withSpaces] || WORK_STATUS_ALIASES[normalized]
  if (canonicalFromAlias) return canonicalFromAlias
  return WORK_STATUS_ACTIVE
}

export const deriveWorkStatus = (worker) => {
  if (worker?.work_status || worker?.status) {
    return normalizeWorkStatus(worker.work_status || worker.status)
  }
  if (worker?.is_active === false) return WORK_STATUS_PAUSED
  return WORK_STATUS_ACTIVE
}

export const formatAccessRoleLabel = (value) =>
  ACCESS_ROLE_LABELS[normalizeAccessRole(value)] || ACCESS_ROLE_LABELS[ACCESS_ROLE_EMPLOYEE]

export const formatWorkStatusLabel = (value) =>
  WORK_STATUS_LABELS[normalizeWorkStatus(value)] || WORK_STATUS_LABELS[WORK_STATUS_ACTIVE]
